export const GET_LIST_CONFIGS = '/config/list';
export const GET_CONFIG_INFO = '/config/getById';
export const CREATE_CONFIG = '/config/create';
export const UPDATE_CONFIG = '/config/update';
export const DELETE_CONFIG = '/config/delete';
